import {default as HomeSwiper} from './homeSwiper';


const components = [
  HomeSwiper
];

// eslint-disable-next-line one-var
const install = (Vue) => {
  components.map(component => {
    Vue.use(component);
  });
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export {
  install,
  HomeSwiper
};

export default {
  install,
};



// WEBPACK FOOTER //
// ./src/components/index.js